<ion-list lines="none" id="login-form-list">

  <div id="bb-info">
    <img src="assets/image/bb-logo.png" alt="" height="50" />
    <p>Already have a Bid Beacon account? Use the same Email Address and Password!</p>
  </div>

  <app-email-input [(ngModel)]="model.username" [required]="true" label="Email Address"></app-email-input>

  <div class=" mb20px">
    <app-password-input id="password" [(ngModel)]="model.password" [required]="true" label="Password"
      [show]="showPwd"></app-password-input>
  </div>

  <ion-button *ngIf="pageState.busy != true" size="block" shape="round" (click)="login()">Login</ion-button>


  <ion-button class="bold" *ngIf="pageState.busy != true" id="forgot" size="block" fill="clear" style="margin-top:10px;"
    (click)="goToForgot()">
    <i>I forgot my password...</i>
  </ion-button>

  <div class="ion-text-center" [hidden]="pageState.busy == false">
    <ion-spinner name="dots" color="login-color"></ion-spinner>
  </div>


  <div class="btn-wrapper" [hidden]="pageState.busy == true">
    <div id="new-fb-button" (click)="facebookLogin()">
      <div>Sign in with <span>Facebook</span></div>
      <ion-icon name="logo-facebook"></ion-icon>
    </div>
    <div [id]="googleBtnId" class="btn_wrapper"></div>
    <ion-button *ngIf="pageState.busy === false" class="bold create-btn" size="block" fill="clear" (click)="register()">
      Create An Account
    </ion-button>
  </div>

</ion-list>